const thewestSerif = `'Guardian Text Egyptian Web', 'Times New Roman', serif`
const thewestSansSerif = `'Guardian Sans Web', 'Helvetica Neue', Helvetica, Arial, sans-serif`
const thewestSansSerifCond = `'Guardian Sans Cond Web', Impact, Helvetica, Arial, sans-serif`

const thenightlySansSerif = `'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif`
const thenightlySansSerifCond = `'Source Serif 4', Impact, Helvetica, Arial, sans-serif`

const perthnowSerif = `'Guardian Text Egyptian Web', 'Times New Roman', serif`
const perthnowSansSerif = `'Guardian Sans Web', 'Helvetica Neue', Helvetica, Arial, sans-serif`
const perthnowSansSerifCond = `'Guardian Sans Cond Web', Impact, Helvetica, Arial, sans-serif`

const sevenwestSansSerif = `'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif`
const sevenwestSansSerifCond = `'Roboto Condensed', 'Arial Narrow', Helvetica, Arial, sans-serif`
const sevenwestSansSerifBauhaus = `HeyWow, 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif`

const designSystemSerif = thewestSerif
const designSystemSansSerif = thewestSansSerif
export interface Fonts {
    serif?: string
    sansSerif: string
    sansSerifCond: string
    heading: string
    headingAlternative?: string
    subheading: string
    body: string
    cards: {
        headline: string
        headlineAlternative?: string
    }
    pullQuote: {
        text: string
        attribution: string
    }
    publication: {
        headline: string
        byline: string
    }
    sponsored: {
        label: string
    }
    subscriber: { text: string }
    navigation: string
}

export const fonts = {
    designSystem: {
        serif: designSystemSerif,
        sansSerif: designSystemSansSerif,
        sansSerifCond: designSystemSansSerif,
        heading: designSystemSansSerif,
        subheading: designSystemSansSerif,
        body: designSystemSerif,
        pullQuote: {
            text: designSystemSerif,
            attribution: designSystemSerif,
        },
        sponsored: {
            label: designSystemSansSerif,
        },
        publication: {
            headline: designSystemSansSerif,
        },
    },

    thewest: {
        serif: thewestSerif,
        sansSerif: thewestSansSerif,
        sansSerifCond: thewestSansSerifCond,
        heading: thewestSerif,
        subheading: thewestSerif,
        body: thewestSerif,
        navigation: thewestSansSerif,
        cards: {
            headline: thewestSerif,
            headlineAlternative: thewestSansSerif,
        },
        pullQuote: {
            text: thewestSerif,
            attribution: thewestSerif,
        },
        sponsored: {
            label: thewestSansSerif,
        },
        publication: {
            headline: thewestSerif,
            byline: thewestSerif,
        },
        subscriber: {
            text: thewestSansSerif,
        },
    },

    thenightly: {
        sansSerif: thenightlySansSerif,
        sansSerifCond: thenightlySansSerifCond,
        heading: thenightlySansSerif,
        subheading: thenightlySansSerif,
        body: thenightlySansSerifCond,
        navigation: thenightlySansSerif,
        cards: {
            headline: thenightlySansSerif,
            headlineAlternative: thenightlySansSerif,
        },
        pullQuote: {
            text: thenightlySansSerifCond,
            attribution: thenightlySansSerif,
        },
        sponsored: {
            label: thenightlySansSerif,
        },
        publication: {
            headline: thenightlySansSerif,
            byline: thenightlySansSerif,
        },
        subscriber: {
            text: thenightlySansSerif,
        },
    },

    perthnow: {
        serif: perthnowSerif,
        sansSerif: perthnowSansSerif,
        sansSerifCond: perthnowSansSerifCond,
        heading: perthnowSansSerifCond,
        subheading: perthnowSansSerifCond,
        body: perthnowSerif,
        navigation: perthnowSansSerifCond,
        cards: {
            headline: perthnowSansSerifCond,
        },
        pullQuote: {
            text: perthnowSerif,
            attribution: perthnowSansSerif,
        },
        sponsored: {
            label: perthnowSansSerifCond,
        },
        publication: {
            headline: perthnowSansSerifCond,
            byline: perthnowSansSerif,
        },
        subscriber: {
            text: perthnowSansSerif,
        },
    },

    sevennews: {
        sansSerif: sevenwestSansSerif,
        sansSerifCond: sevenwestSansSerifCond,
        heading: sevenwestSansSerifCond,
        headingAlternative: sevenwestSansSerifBauhaus,
        subheading: sevenwestSansSerif,
        body: sevenwestSansSerif,
        navigation: sevenwestSansSerifCond,
        cards: {
            headline: sevenwestSansSerifCond,
        },
        pullQuote: {
            text: sevenwestSansSerifCond,
            attribution: sevenwestSansSerif,
        },
        sponsored: {
            label: sevenwestSansSerif,
        },
        publication: {
            headline: sevenwestSansSerifCond,
            byline: sevenwestSansSerif,
        },
        subscriber: {
            text: sevenwestSansSerif,
        },
    },
}
